/**
 * Todo texto vindo da API — nome de entidade, predicado, conteudo de memoria — passa por aqui
 * antes de entrar em innerHTML. O conteudo do grafo e escrito por um modelo a partir do que o
 * usuario digitou, entao tratar essa origem como confiavel seria injecao garantida.
 */
export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}
